// Email action links (verify address, reset password) land on the app itself, where
// AuthAction.svelte applies the code and shows the result in PassCall's own words.
//
// The emails are sent by the sendAuthEmail Cloud Function (cloud-functions/lib/authmail.js):
// PassCall wording, from help@passcall.io through Resend, link on my.passcall.io. Firebase's
// stock templates cannot be customised on this project (the console and the admin API both
// refuse with EMAIL_TEMPLATE_UPDATE_NOT_ALLOWED), so Firebase's own mailer is only the
// fallback when the function cannot be reached.

const FUNCTION_URL = "https://us-central1-knolval-3f384.cloudfunctions.net/sendAuthEmail";

async function callSendAuthEmail(data, idToken) {
  const controller = typeof AbortController === "function" ? new AbortController() : null;
  const timer = controller ? setTimeout(() => controller.abort(), 20000) : null;
  try {
    const headers = { "Content-Type": "application/json" };
    if (idToken) headers.Authorization = "Bearer " + idToken;
    const res = await fetch(FUNCTION_URL, { method: "POST", headers, body: JSON.stringify({ data }), signal: controller ? controller.signal : undefined });
    const body = await res.json().catch(() => ({}));
    if (!res.ok || !body.result) {
      const err = body.error || {};
      const e = new Error(err.message || "HTTP " + res.status);
      // RESOURCE_EXHAUSTED is the function's own rate limit: surface it like Firebase's.
      e.code = err.status === "RESOURCE_EXHAUSTED" ? "auth/too-many-requests" : "functions/" + String(err.status || res.status).toLowerCase();
      throw e;
    }
    return body.result;
  } finally {
    if (timer) clearTimeout(timer);
  }
}

export async function sendVerificationEmail(user) {
  try {
    const token = await user.getIdToken();
    return await callSendAuthEmail({ kind: "verify" }, token);
  } catch (e) {
    if (e && e.code === "auth/too-many-requests") throw e;
    console.warn("sendAuthEmail unavailable, using Firebase's template", e);
    return user.sendEmailVerification();
  }
}

export async function sendPasswordResetEmail(auth, email) {
  try {
    return await callSendAuthEmail({ kind: "reset", email });
  } catch (e) {
    if (e && e.code === "auth/too-many-requests") throw e;
    console.warn("sendAuthEmail unavailable, using Firebase's template", e);
    return auth.sendPasswordResetEmail(email);
  }
}

/** The action carried by the current URL, or null. */
export function actionFromUrl() {
  const p = new URLSearchParams(window.location.search);
  const mode = p.get("mode");
  const code = p.get("oobCode");
  if (!mode || !code) return null;
  return { mode, code };
}

/** Remove the action parameters so a reload does not replay the code. */
export function clearActionFromUrl() {
  try {
    window.history.replaceState(null, "", window.location.pathname);
  } catch (e) {
    /* ignore */
  }
}
